<template>
  <v-card class=" " elevation="0">
    <v-row align="start" cols="12">
      <v-col cols="12" xs="12" sm="12" :md="showStockSettings ? 6 : 9" :lg="showStockSettings ? 6 : 9" :xl="showStockSettings ? 6 : 9" class="  ">
        <v-card-title class="main-title">
          <v-icon
              v-if="haveBack"
              color="normalred"
              style="cursor: pointer"
              @click="voltar('/product-resale')"
              class="mr-2 ma-0 pa-0"
              size="26"
          >
            mdi-arrow-left
          </v-icon>
          {{ title }}
        </v-card-title>
        <v-card-text class="card-text">{{ text }}</v-card-text>
      </v-col>

      <v-col v-if="showStockSettings" cols="12" xs="12" sm="12" md="3" lg="3" xl="3"  >
        <label>Configuração de ofertas/estoque</label>
        <v-select
            hide-details
            outlined
            :items="stockSettingsTypesFull"
            v-model="resale.stockSettings"
            @change="updateStockSettings()"
            class="primary-input"
            placeholder="Selecione a configuração de ofertas/estoque"
            append-icon="mdi-chevron-down"
            item-text="text"
            item-value="value"
            dense
            height="41"
            full-width
        >
        </v-select>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <div class=" ">
          <v-btn
              class="
            header-button
            hidden-sm-and-down
            align-items-center ml-3 mb-3"
              style="border-radius: 10px "
              v-if="haveAction"
              color="normalred"
              elevation="0"
              @click="action"
          >{{ actionTitle }}
          </v-btn
          >

          <v-btn
              fab
              tile
              small
              style="border-radius: 6px box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);"
              class="header-button hidden-md-and-up"
              v-if="haveAction"
              color="normalred"
              elevation="2"
              @click="action"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn
          >
        </div>

        <slot></slot>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.main-title {
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 35px;
  color: #000000;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 35px;

  width: 70%;

  color: #9c9c9c;
}

.v-btn {
  font-weight: bold;
  width: 250px;
  border-radius: 10px;
  height: 50px;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

/* .container {
	max-width: 172px;
	margin: 0 auto;
	border: 1px solid rgb(19, 18, 18);
} */

@media (max-width: 900px) {
  .card-text {
    font-size: 1rem;
    width: 80%;
  }
}
</style>

<script>
import ApiService from "@/services/ApiService";

export default {
  name: "HeaderCard",

  data: () => ({
    stockSettingsTypesFull: [
      {value: 1, text: "Habilitar envio de ofertas para a loja"},
      {value: 2, text: "Habilitar envio de estoque para o buscador"},
      {value: 0, text: "Habilitar envio de ofertas para a loja e estoque para buscador"}
    ],
    resale: Object,
    apiService: new ApiService(),
  }),
  props: {
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
    haveBack: Boolean,
    mainPage: Boolean,
    resaleId: {type: String, default: null, require: false},
    showStockSettings: {type: Boolean, default: false, require: false},
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },

    action3() {
      this.$emit("action3");
    },
    getResale() {
      this.apiService.get(`resale/get-one?id=${this.resaleId}`).then((response) => {
        this.resale = response;
      });
    },

    updateStockSettings(){
      this.apiService
          .put(`resale/stock-settings/${this.resaleId}`, this.resale)
          .then((resp) => {
            this.$toast.success("Atualizado com sucesso");
            this.getResale()
          });
    },

    async voltar(item) {
      await this.$router.go(-1);
    },
  },
};
</script>
